import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import { Button, Anchor } from "hesus-ui-kit";
import {
  GridRow,
  GridCell,
  GridCellTitle,
  GridCellValue,
} from "../../InvoiceView.styled";

const AdditionalDocumentInformation = ({
  t,
  invoiceData,
  internalComment,
  setInternalComment,
  isSubmitting,
  onCommentUpdate,
}) => {
  return (
    <>
      <GridRow background="#008395" borderRadius="5px 5px 0 0px">
        <GridCell fontWeight="700" fontSize="16px">
          {t("CLIENT_INVOICING_SECTION_ADDITIONAL_INFO")}
        </GridCell>
      </GridRow>
      <GridRow
        column="1fr"
        boxShadow="0px 1px 1px 1px #e5e5e5"
        margin="0 0 12px 0"
        padding="0px"
        gap="0px"
      >
        <GridRow column="auto 1fr" gap="10px">
          <GridCellTitle fontSize="15px">
            {t("CLIENT_INVOICING_LINK_TO_SUMMARIES")} :
          </GridCellTitle>
          <GridCellValue fontSize="15px">
            {invoiceData?.linkToSummaries ? (
              <Anchor
                url={`/invoice/view/${invoiceData?.linkToSummaries}`}
                target="_blank"
                rel="noopener noreferrer"
                styles={{
                  color: "#1bace4",
                  textDecoration: "underline",
                }}
              >
                {`#${invoiceData.linkToSummaries}`}
              </Anchor>
            ) : (
              ""
            )}
          </GridCellValue>
        </GridRow>
        <GridRow column="1fr" gap="0px" padding="0 16px 5px 16px">
          <GridCellTitle fontSize="15px">
            {t("CLIENT_INVOICING_INTERNAL_COMMENTS")} :
          </GridCellTitle>
        </GridRow>
        <GridRow column="1fr" gap="0px" padding="0 16px 12px 16px">
          <CKEditorText
            descriptionData={internalComment || ""}
            setDescriptionData={setInternalComment}
          />
        </GridRow>
        <GridRow column="1fr auto " padding="0 16px 12px" background="none">
          <div></div>
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onCommentUpdate}
          >
            <>
              {isSubmitting && <ClipLoader size={15} color="#fff" />}
              {!isSubmitting && t("CLIENT_INVOICE_SAVE")}
            </>
          </Button>
        </GridRow>
      </GridRow>
    </>
  );
};

AdditionalDocumentInformation.propTypes = {
  t: PropTypes.func.isRequired,
};

AdditionalDocumentInformation.defaultProps = {
  
};

export default withTranslation()(AdditionalDocumentInformation);
